import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleLeft, faAngleDoubleUp, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import './ContentLinks.css';


class ContentLinks extends Component {
  renderLink(link) {
    return <a href={link.url}>{link.title}</a>
  }

  getDefaultIndex() {
    const url = window.location.href
    const pathIndex = url.indexOf('/', url.indexOf('://') + 3)
    const baseURL = pathIndex >= 0 ? url.substring(0, pathIndex) : url
    return {
      title: '最近参照した問題',
      url: baseURL + '/recent/'
    }
  }

  render() {
    const index = this.props.index || this.getDefaultIndex()
    return <Container className='ContentLinks'>
        <Row>
          <Col sm={4} className='ContentLink ContentLinkPrevious'>
            {this.props.previous && <span>
                <FontAwesomeIcon icon={faAngleDoubleLeft} />
                前 {this.renderLink(this.props.previous)}
              </span>}
          </Col>
          <Col sm={4} className='ContentLink ContentLinkIndex col-sm'>
            {index && <span>
                <FontAwesomeIcon icon={faAngleDoubleUp} />
                戻る {this.renderLink(index)}
              </span>}
          </Col>
          <Col sm={4} className='ContentLink ContentLinkNext col-sm'>
            {this.props.next && <span>
                {this.renderLink(this.props.next)} 次
                <FontAwesomeIcon icon={faAngleDoubleRight} />
              </span>}
          </Col>
        </Row>
      </Container>
  }
}

export default ContentLinks;
